import { regex_no_num, regex_num } from "../../constants/regex";

const doctorHandleChange = ({ name, value }, setData) => {
    if (name === 'name') {
        if (value === '' || regex_no_num.test(value))
            setData(e => ({
                ...e, [name]: value
            }));
    } else if (['phone', 'professionalID'].includes(name)) {
        if (value === '' || regex_num.test(value))
            setData(e => ({
                ...e, [name]: value
            }));
    } else if (name === 'email')
        setData(e => ({
            ...e, [name]: value.toLowerCase()
        }));
    else
        setData(e => ({
            ...e, [name]: value
        }));
};

export {
    doctorHandleChange
};